<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-HengFu`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6283 6.23621C10.2333 5.7572 7.76708 5.7572 5.37203 6.23621L4.50018 6.41058V11.3908L5.17591 11.2556C7.70042 10.7507 10.2999 10.7507 12.8244 11.2556L13.5002 11.3908V6.41058L12.6283 6.23621ZM13.5002 12.4106L12.6283 12.2362C10.2333 11.7572 7.76708 11.7572 5.37203 12.2362L4.50018 12.4106V13.5007H0.065918L2.39925 10.0007L0.065918 6.50068H3.50018V5.59078L5.17591 5.25563C7.70042 4.75073 10.2999 4.75073 12.8244 5.25563L14.5002 5.59078V6.50068H17.9344L15.6011 10.0007L17.9344 13.5007H13.5002V12.4106ZM14.5002 7.50068V9.84929L16.0659 7.50068H14.5002ZM14.5002 10.1521V12.5007H16.0659L14.5002 10.1521ZM3.50018 7.50068H1.93444L3.50018 9.84929V7.50068ZM3.50018 10.1521L1.93444 12.5007H3.50018V10.1521Z"/></svg>
</template>
<script>

export default {
  name: 'IconHengFu',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
